module.exports = __webpack_public_path__ + "assets/img/aristotle.36e3605a.jpg";